import TH_ModalDialog from '_tradeholding/js/Classes/ModalDialog';
import defaultDialogTemplate from '_mustache/components/dialog.portfolio.mustache';

import '_premierworld/scss/components/dialog.scss';

class ModalDialog extends TH_ModalDialog {
    constructor(options, template) {
        super(options, template);
    }

    /** Set the default template for the dialog
     * 
     */
    __setDefaultTemplate() {
        this.template = defaultDialogTemplate;
    }
}

export default ModalDialog;